import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import {
  REVYRE_DETAILS,
  REVYRE_DETAILS_360,
  REVYRE_WORKFLOW_DETAILS,
  REVYRE_WORKFLOW_DETAILS_360,
} from 'src/modules/constants';
import { renderModule } from 'src/workspace/slice';

export const handleSearchNavigation = (
  item: any,
  type: string,
  dispatch: any,
) => {
  if (type === 'revyre') {
    const workflowType = item?.workflowType;
    const entityId = item?.id;
    const newDetailsPage = getGrowthBookFeatureFlag('enable-details-360');
    if (!['activity', 'approval'].includes(workflowType)) {
      dispatch(
        renderModule({
          id: newDetailsPage
            ? REVYRE_WORKFLOW_DETAILS_360
            : REVYRE_WORKFLOW_DETAILS,
          props: {
            domainType: 'workflow',
            workflowType,
            entityId,
          },
        }),
      );
    } else {
      dispatch(
        renderModule({
          id: newDetailsPage ? REVYRE_DETAILS_360 : REVYRE_DETAILS,
          props: {
            domainType: workflowType,
            entityId,
          },
        }),
      );
    }
  }
};
